import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface User {
  id: string
  username: string
  avatar: string
  twitterHandle: string
  walletAddress: string
  lunaticsOwned: number
  socialScore: number
  rank: number
  isVerified: boolean
}

interface Tweet {
  id: string
  userId: string
  username: string
  avatar: string
  content: string
  timestamp: string
  likes: number
  retweets: number
  replies: number
  mentions: string[]
  hashtags: string[]
}

interface NFTData {
  floorPrice: number
  volume24h: number
  totalVolume: number
  totalSupply: number
  holders: number
  change24h: number
}

interface Store {
  // UI State
  sidebarOpen: boolean
  setSidebarOpen: (open: boolean) => void
  
  // User State
  user: User | null
  setUser: (user: User | null) => void
  
  // Social Data
  tweets: Tweet[]
  setTweets: (tweets: Tweet[]) => void
  
  // NFT Data
  nftData: NFTData
  setNftData: (data: NFTData) => void
  
  // Leaderboard
  leaderboard: User[]
  setLeaderboard: (users: User[]) => void
  
  // Wallet
  walletConnected: boolean
  setWalletConnected: (connected: boolean) => void
  
  // Theme
  theme: 'dark' | 'light'
  setTheme: (theme: 'dark' | 'light') => void
}

export const useStore = create<Store>()(
  persist(
    (set) => ({
      // UI State
      sidebarOpen: true,
      setSidebarOpen: (open) => set({ sidebarOpen: open }),
      
      // User State
      user: null,
      setUser: (user) => set({ user }),
      
      // Social Data
      tweets: [],
      setTweets: (tweets) => set({ tweets }),
      
      // NFT Data
      nftData: {
        floorPrice: 0,
        volume24h: 0,
        totalVolume: 0,
        totalSupply: 10000,
        holders: 0,
        change24h: 0,
      },
      setNftData: (data) => set({ nftData: data }),
      
      // Leaderboard
      leaderboard: [],
      setLeaderboard: (users) => set({ leaderboard: users }),
      
      // Wallet
      walletConnected: false,
      setWalletConnected: (connected) => set({ walletConnected: connected }),
      
      // Theme
      theme: 'dark',
      setTheme: (theme) => set({ theme }),
    }),
    {
      name: 'lunatics-socialfi-store',
      partialize: (state) => ({
        theme: state.theme,
        sidebarOpen: state.sidebarOpen,
      }),
    }
  )
) 